<template>
  <div class="order-status-step">
    <div class="list-step mt16">
      <div class="title-box title-box-1">
        <div class="step-title">
          <el-image :src="cheImage" class="title-label"></el-image>订单状态
        </div>
        <div :class="'sty' + detailData.orderStatus">
          {{ getLocalLabel("orderStatus", detailData.orderStatus) }}
        </div>
        <div v-if="showPayBtn" style="margin-left: 20px">
          <div v-if="detailData.orderStatus === 1">
            <el-button type="primary" @click="checkPayQr()">生成支付二维码</el-button>
          </div>
        </div>

      </div>
<!--      <div class="list-label">-->
<!--        <div :class="'sty' + detailData.orderStatus">-->
<!--          {{ getLocalLabel("orderStatus", detailData.orderStatus) }}-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="step-container">
      <div class="step-content">
        <div
          class="step-list"
          v-for="(item, index) in detailData.steps"
          :key="index"
        >
          <div class="step-list-content">
            <div
              @click="
                isCheckDetail(item.stepStatus, item.stepType)
                  ? handleCheckDetail(item)
                  : ''
              "
              :class="
                isCheckDetail(item.stepStatus, item.stepType) &&
                stepActiveLength === index + 1
                  ? 'step-box'
                  : 'step-box-none'
              "
            >
              <div class="step-date">{{ item.createTime }}</div>
              <div class="step-name">
<!--                <template v-if="detailData?.driver?.driverType !== 2">-->
                <span :class="item.stepStatus !== 1 ? 'color8c8c8c' : ''">{{
                  item.content
                }}</span>
                <i
                  class="el-icon-arrow-right"
                  v-if="isCheckDetail(item.stepStatus, item.stepType)"
                ></i>
<!--                </template>-->
<!--                <template v-else>-->
<!--                <span >{{-->
<!--                    item.content-->
<!--                  }}</span>-->
<!--                </template>-->
              </div>
<!--              临调司机要单独处理-->
              <template v-if="detailData?.driver?.driverType === 2">
                <div v-if="item.stepType === 21 || item.stepType === 22">
                  <el-button style="margin-top: 5px" size="mini" v-if="item.stepStatus === 0 && item.canSkip" @click="handleConfirm(item, index)">完成</el-button>
<!--                  <div style="margin-top: 5px" v-if="item.stepStatus !== 0">已完成</div>-->
                </div>
              </template>

            </div>
          </div>

          <div class="step-line-check" v-if="item.stepStatus === 1">
            <div
              class="step-dot"
              :class="stepActiveLength === index + 1 ? 'step-dot-active' : ''"
            ></div>
            <div class="step-dot-line"></div>
          </div>
          <div class="step-line" v-else>
            <div class="step-dot"></div>
            <div class="step-dot-line"></div>
          </div>
        </div>
      </div>
    </div>
    <stepDetail ref="stepDetail"></stepDetail>
    <payQr ref="payQrRef" @paySuccess="paySuccess"></payQr>
    <stepImg ref="stepImg" @handleAddOrEditSuccess="handleAddOrEditSuccess"></stepImg>
  </div>
</template>
<script>
import { getLocalLabel } from "@/utils/localDict";
import stepDetail from "@/views/OrderManagement/stepDetail.vue";
import payQr from "@/components/payQr.vue";
import stepImg from "@/views/OrderManagement/stepImg.vue";
import { detailInfo } from "@/views/SchedulingWorkbench/OrderReassignment/api";
import { freightSkip } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: { stepDetail,stepImg,payQr },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      detailData: {},
    };
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showPayBtn: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    details: {
      handler(val) {
        this.detailData = this.details;
      },
      deep: true
    }
  },
  mounted() {

  },
  computed: {
    stepActiveLength: function () {
      let num = 0;
      if (this.detailData?.steps && this.detailData.steps.length > 0) {
        this.detailData.steps.forEach((item) => {
          if (item.stepStatus === 1) {
            num++;
          }
        });
      }
      return num;
    },
  },
  methods: {
    getLocalLabel,
    // 支付成功需要处理
    paySuccess() {
      this.$emit("paySuccessRefresh", this.detailData.orderId);
    },
    checkPayQr() {
      this.$refs.payQrRef.init(this.detailData.orderId)
    },
    handleAddOrEditSuccess() {
      this.getOrderDetail(this.detailData.orderId)
    },
    handleConfirm(item, index) {
      // 只有临调司机 和 最后一步 和 电子回单 才走这一步
      if (this.detailData.steps.length === index+1 && this.detailData.receiptType === 2) {
        this.$refs.stepImg.init({
          "orderId": this.detailData.orderId,
          "pointId": item.sourceId,
          "receiptPictures": []
        })
      } else {
        freightSkip({
          "orderId": this.detailData.orderId,
          "pointId": item.sourceId,
          "receiptPictures": []
        }).then((res) => {
            if (res.code === 200) {
              this.getOrderDetail(this.detailData.orderId)
            }
          });
      }
    },
    getOrderDetail(orderId) {
      detailInfo(orderId)
        .then((res) => {
          if (res.code === 200) {
            this.detailData = res.data;
          }
        })

    },
    handleCheckDetail(item) {
      this.$refs.stepDetail.init(item);
    },
    isCheckDetail(stepStatus, stepType) {
      // 1货主下单，2客服代下单，5货主支付，10调度派单，11订单改派，21装货点装货，22卸货点卸货，31订单取消，41订单退款
      let arr = [5, 10, 11, 21, 22, 25, 31, 41];
      if (stepStatus === 0) {
        return false;
      } else {
        if (arr.includes(stepType)) {
          return true;
        }
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-status-step {
  .title-box-1{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .step-title{
      padding-right: 0.2rem;
    }
  }
}
</style>
